import gql from 'graphql-tag';

const IS_SIGNUP_V2_MIGRATION_NEEDED = gql`
  query IsSignupV2MigrationNeeded($campaignOrderId: ID!) {
    isSignupMigrationNeeded(campaignOrderId: $campaignOrderId)
  }
`;

export default IS_SIGNUP_V2_MIGRATION_NEEDED;
